/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Section_DailyInputs */

const en_admin_funnel_section_daily = /** @type {(inputs: Admin_Funnel_Section_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By day`)
};

/**
* | output |
* | --- |
* | "By day" |
*
* @param {Admin_Funnel_Section_DailyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_section_daily = /** @type {((inputs?: Admin_Funnel_Section_DailyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Section_DailyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_section_daily(inputs)
});
export { admin_funnel_section_daily as "admin.funnel.section.daily" }